export default __webpack_public_path__ + "static/media/consultor-ai.72f96904.png";